// Celdas custom pequeñas y reusadas dentro de la definición de columnas.
// Agrupadas en un solo archivo (a diferencia de los modales, que siempre
// viven en su propio archivo) porque son renders triviales sin estado propio.
import React from "react";
import { formatMoney } from "../../../utils/utils";
import { limpiarNotaDescuentoAuto, getDescuentoHorasNota, appendNotaCalculada } from "../helpers";

export const AuxiliarNombreCell = React.memo(({ row }) => {
    if (row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0) {
        return (
            <>
                {row.reemplazoNombre}
            </>
        );
    }
    return <>{row.auxiliarNombre}</>;
});

export const AuxiliarRutCell = React.memo(({ row }) => {
    if (row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0) {
        return (
            <>
                {row.reemplazoRut}
            </>
        );
    }
    return <>{row.auxiliarRut}</>;
});

// Turno extendido: el turno dura más de 12 horas según "Horas por Turno" del paciente
// (dato horas_turno de /turnos/lista). Se muestra como badge antes de la nota, sin
// formar parte del texto de la nota.
const BadgeTurnoExtendido = ({ horas }) => {
    const h = Number(horas) || 0;
    if (h <= 12) return null;
    const texto = Number.isInteger(h) ? String(h) : String(h).replace(".", ",");
    return (
        <span
            className="badge bg-info text-dark me-1 align-middle"
            style={{ fontSize: "0.62rem", padding: "0.15rem 0.3rem", cursor: "help" }}
            title={`Turno extendido ${texto} horas`}
        >
            TE
        </span>
    );
};

export const NotasCell = React.memo(({ row }) => {
    let nota = limpiarNotaDescuentoAuto(row.notes || "");
    const multiAdicional = row.adicionales?.length > 1;

    if (row.reemplazoNombre) {
        nota += ` (Reemplazo) `;
    }

    // Agregar notas internas con separador
    if (row.notas_internas) {
        nota += (nota ? " - " : "") + row.notas_internas;
    }

    if (row.adicionales?.length > 0) {
        row.adicionales.forEach(item => {
            nota += ` - Adicional a ${item.auxiliarNombre} `;

            const addIf = (val, label) => {
                // Solo agrega si es un número diferente de 0
                if (val !== null && val !== undefined && Number(val) !== 0) {
                    nota += ` ${label} $ ${formatMoney(val)}`;
                }
            };

            addIf(item.valorTurno, "turno");
            addIf(item.valorColacion, "colación");
            addIf(item.valorMovilizacion, "movilización");
            addIf(item.valorOtro, "otro");

            if (item.motivoAdicional) {
                nota += ` motivo ${item.motivoAdicional}`;
            }
        });
    }

    nota = appendNotaCalculada(nota, getDescuentoHorasNota(row));

    if (multiAdicional) {
        return (
            <div className="bg-row-rojo-claro px-1 rounded" style={{ height: '100%', width: '100%' }}>
                <BadgeTurnoExtendido horas={row.horas_turno} />
                {nota}
            </div>
        );
    }

    return <><BadgeTurnoExtendido horas={row.horas_turno} />{nota}</>;
});
